<template>
    <div>
        <v-card class="mt-2 pb-0 mb-5">
            <v-card-title class="pa-5 pb-3 primary">
                <p style="color: white;"> Decálogo Recuperaciones </p>
            </v-card-title>

            <v-card-text style="margin-bottom: 4%;">
                <v-row justify="center">
                    <v-col cols="12" md="6">
                        <div class="mt-3">
                            <v-form ref="form" v-model="validForm" lazy-validation>
                                <h4 class="text-info" style=" font-size: 18px; font-weight: bold;">
                                    Selecciona las opciones para el decálogo de recuperaciones:
                                </h4>
                                <v-row>
                                    <v-col md="12">
                                        <div v-for="(item, index) in recuperaciones" :key="index">
                                            <v-list-item>
                                                <v-list-item-action class="mr-1">
                                                    <v-checkbox :value="item.reclave" v-model="arrayRecuperaciones"
                                                        @click="validarRespuestas(item.reclave)"></v-checkbox>
                                                </v-list-item-action>
                                                <v-list-item-content class="document-chekboxes-style">
                                                    {{ item.redescripcion }}
                                                </v-list-item-content>
                                            </v-list-item>
                                        </div>
                                    </v-col>
                                </v-row>
                                <br />
                            </v-form>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions style="justify-content: center; align-content:end; padding: 20px;">
                <v-row justify="center" class="mb-8">
                    <v-btn class="ma-2" color="#536DFE" style="color:white" :disabled="disBtn"
                        @click="Guardar()">Guardar</v-btn>
                    <v-btn class="ma-2" color="default" @click="limpiar()" :disabled="disBtn">
                        Limpiar
                    </v-btn>
                    <v-btn class="ma-2" color="error" @click="Cancelar()" :disabled="disBtn">Cancelar</v-btn>
                </v-row>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import Lideres from "@/services/Lideres/Lideres.service.js";

import { mapState } from "vuex";
    export default {
        title() {
            return this.$route.meta.title
        },
    data() {
        return {
            recuperaciones: [],
            arrayRecuperaciones: [],
            disBtn: false,
            validForm: true,
            reporte: {
                nrreporte: 0,
                svindice: 0
            },
            permisoLideres: false,
        }
    },
    computed: {
        ...mapState(['domain', 'informationPage']),
    },

    async beforeMount() {
        await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '40').then(response => {
            if (response.data.length > 0) {
                response.data.forEach(permiso => {
                    if (permiso.peclave == 40)//Permiso para ver lideres
                        this.permisoLideres = true;
                });
            }
            if (this.permisoLideres == false) {
                this.$router.push({ name: `NoAutorizado` }).catch(error => error);
            }
        });
    },
    async mounted() {
        let reporte = await MetodosGenerales.obtenerSessionReporte('valider');
        this.reporte.nrreporte = reporte.nrreporte;
        this.reporte.svindice = reporte.svindice;
        this.reporte.aiclave = reporte.aiclave;
        this.reporte.svfhconclusion = reporte.svfhconclusion;
        await Lideres.CatalogoRecuperaciones(this);
    },
    methods: {
        limpiar() {
            this.arrayRecuperaciones = [];
        },
        Cancelar() {
            this.$router.push({ name: `AgregarMovimientoValider` }).catch(error => error);
        },
        async validarRespuestas(reclave) {
            let response = await Lideres.ValidacionRecuperacion(this.reporte, reclave)
            if (response != null) {
                const index = this.arrayRecuperaciones.indexOf(reclave);
                if (index !== -1) {
                    this.arrayRecuperaciones.splice(index, 1);
                }
                this.$swal({
                    position: "center",
                    icon: "warning",
                    title: "Alerta",
                    html: `${response}`,
                    confirmButtonText: "Aceptar",
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    allowHtmlTags: true,
                }).then(() => {
                });
            }
        },
        async Guardar() {
            this.$refs.form.validate();
            if (this.arrayRecuperaciones.length == 0) {
                this.$swal({
                    position: "center",
                    icon: "info",
                    title: "Información",
                    text: "No se ha seleccionado ninguna opción del decálogo ¿Desea continuar?",
                    showCancelButton: true,
                    confirmButtonColor: '#536DFE',
                    cancelButtonColor: '#FF5C93',
                    confirmButtonText: 'Continuar',
                    cancelButtonText: 'Revisar de nuevo',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        let response = await Lideres.AgregarMovimientosRecuperacion(this.reporte, '', 0)
                        this.$emit('Precierre');
                    }
                });
            } else {
                this.$swal({
                    title: 'Procesando solicitud',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: async () => {
                        this.disBtn = true;
                        this.$swal.showLoading();
                        const valoresSeleccionados = this.arrayRecuperaciones.map(reclave => {
                            const recuperacion = this.recuperaciones.find(item => item.reclave === reclave);
                            return recuperacion ? recuperacion.revalor : 0;
                        });
                        let total = valoresSeleccionados.reduce((total, valor) => total + valor, 0);
                        let response = await Lideres.AgregarMovimientosRecuperacion(this.reporte, this.arrayRecuperaciones.join(), total)
                        if (response.length == 0) {
                            this.$swal({
                                position: "center",
                                icon: "success",
                                title: "Correcto",
                                text: "Datos guardados correctamente.",
                                showConfirmButton: true,
                                allowOutsideClick: false,
                                confirmButtonColor: '#536DFE',
                                confirmButtonText: 'Aceptar',
                                timer: 3000,
                            }).then(() => {
                                this.$emit('Precierre');
                            });
                        } else {
                            this.$swal({
                                position: "center",
                                icon: "warning",
                                title: "Error",
                                text: "Ocurrió un error, intente nuevamente más tarde, si el problema persiste, pónganse en contacto con el área de soporte.",
                                showConfirmButton: false,
                                allowOutsideClick: false,
                                timer: 2500,
                            });
                            this.disBtn = false;
                        }
                    }
                });
            }
        }
    }
}
</script>

<style scoped>
.error-message-style {
    font-family: "Roboto", sans-serif;
    color: #FF5C93;
    font-weight: 400;
    font-size: 12px;
}
</style>